"use strict";

var _defineProperty = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/defineProperty.js");

var _exports$headerConfig;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerConfigData = exports.companyNameData = void 0; // Layout related configurations for header/footer  (based on companyName)
// For Menus the data (contentful) determines wether the menu appears or not

var frontend_application_1 = require("@ryerson/frontend.application");

var common_constants_1 = require("@ryerson/common.constants"); // Note: this needs to align with "process.env.GATSBY_COMPANY"  values


exports.companyNameData = {
  ryerson: "ryerson",
  southernToolSteel: "southernToolSteel"
}; // Header Component Settings Data:

exports.headerConfigData = (_exports$headerConfig = {}, _defineProperty(_exports$headerConfig, exports.companyNameData.ryerson, {
  utilityMenus: {
    phoneNumber: function phoneNumber(country) {
      return common_constants_1.PhoneNumbers.PHONE_NUMBERS.ryerson[country];
    },
    showLanguage: true,
    showCountry: true,
    showLocation: true
  },
  globalMenus: {
    showStockList: true,
    containerWidth: function containerWidth(language) {
      return frontend_application_1.Language.en === language ? "520px" : "420px";
    }
  }
}), _defineProperty(_exports$headerConfig, exports.companyNameData.southernToolSteel, {
  utilityMenus: {
    phoneNumber: function phoneNumber(country) {
      return common_constants_1.PhoneNumbers.SOUTHERN_TOOL_STEEL;
    },
    showLanguage: true,
    showCountry: true,
    showLocation: true
  },
  globalMenus: {
    showStockList: false,
    containerWidth: function containerWidth(language) {
      return frontend_application_1.Language.en === language ? "470px" : "330px";
    }
  }
}), _exports$headerConfig);